module.exports = __webpack_public_path__ + "static/media/jasmine-win.908bbdd5.png";